<script>
    import { getContext } from 'svelte'; const dispatch = getContext('dispatch');
    export let message;
    export let tooltip = null;
    export let style = '';
</script>

<style lang="less">
    @import "./common.less";
    a {
        color: @buttonTextColor;
        font-family: oswald;
    }
    a :global(path.stroke) {
        stroke: @buttonTextColor;
    }
    a :global(path.fill) {
        fill: @buttonTextColor;
    }
    a:hover {
        color: @brightFg;
        background-color: @buttonHoverColor;
    }
    a:hover :global(path.stroke) {
        stroke: @brightFg;
    }
    a:hover :global(path.fill) {
        fill: @brightFg;
    }
    a {
        flex: 1 0 0;
        display: block;
        padding: 6px 15px;
        margin: 0;
        font-size: inherit;
        text-decoration: none;
        background: @buttonColor;
        border: 1px solid @buttonBorderColor;
        border-radius: 20px;
        display: grid;
        align-items: center;
    }
</style>

<a href="#a" {style} title={tooltip} on:click|preventDefault|stopPropagation={() => {dispatch(message)}}><slot/></a>